import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectFlightsScheduleReport, selectFlightsScheduleReportData, selectFlightsScheduleColumns } from '_redux/slices/total-reports/total-reports';
import CustomReportsTable from './custom-reports-table';
import { Button } from 'react-bootstrap';
import moment from 'moment';
import { sanitizeSpreadsheetCell } from '_utils/sanitize-spreadsheet-cell';

const FlightReport = () => {

    const flightsScheduleReport = useSelector(selectFlightsScheduleReport);
    const flightsReportData = useSelector(selectFlightsScheduleReportData);
    const flightsReportColumns = useSelector(selectFlightsScheduleColumns);

    /*

    useEffect(() => {
        console.log('flightsScheduleReport', flightsScheduleReport);
    }, [flightsScheduleReport]);

    useEffect(() => {
        console.log('flightsReportColumns', flightsReportColumns);
    }, [flightsReportColumns]);

    useEffect(() => {
        console.log('flightsReportData', flightsReportData);
    }, [flightsReportData]);

    */

    //#region CSV helper functions
    const escapeCSV = (v) => {
        if (v === null || v === undefined) return "";
        const s = String(sanitizeSpreadsheetCell(v));
        // quote if it has comma, quote, or newline
        if (/[",\r\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
        return s;
    };

    const toCSV = (headers, rows) => {
        const head = headers.map(escapeCSV).join(",");
        const body = rows.map(r => r.map(escapeCSV).join(",")).join("\r\n");
        return `${head}\r\n${body}`;
    };

    const downloadCSV = (csvString, filename = "data.csv") => {
        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleExportReport = () => {
        if (!hasData) return;

        // Get headers from columns
        const headers = flightsReportColumns.map(c => c.name);
        
        // Data is already in array format matching the column order
        // Each flight is an array, not an object
        const rows = flightsReportData;

        // Create filename with current date
        const currentDate = moment().format("YYYY-MM-DD");
        const fileName = `flights-schedule-report_${currentDate}.csv`;

        // Generate and download CSV
        const csv = toCSV(headers, rows);
        downloadCSV(csv, fileName);
    };

    //#endregion

    const hasData = flightsReportData && flightsReportData?.length > 0;

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <p style={{ margin: 0 }}>
                    Total Flights: {flightsScheduleReport?.totalFlights || 0}
                </p>
            </div>

            <CustomReportsTable 
                data={flightsReportData} 
                columns={flightsReportColumns} 
                maxHeight={"600px"} 
                minHeight={"600px"} 
            />

            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                <div />
                {hasData &&
                <Button 
                    onClick={handleExportReport}
                    disabled={!hasData}
                >
                    Export Report
                </Button>
                }
            </div>

        </div>
        
    );
};

export default FlightReport;

